import request from "@/services/axios";

export function authBasicCheck(data, props = {}) {
  return request({
    url: "auth/basic/check",
    method: "post",
    data,
    ...props,
  });
}

export function authBasicLogin(data, props = {}) {
  return request({
    url: "auth/basic/login",
    method: "post",
    data,
    ...props,
  });
}
